export const environment = {
  production: true,
  host: 'cometralci.com',
  stripePublishableKey:
    'pk_live_51SpXQTAU1Ecc5V1xh3tYVc3qhPNVsQ00YN1xknxIwN26fEfm3JSZRZW5UsdJ4OYoXhRkdBQWDOESXoyZuWU5kjZ600ktHLNmMk',
  get apiUrl() {
    return `/api`;
  },
};
